import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceModal = ({ service, isOpen, onClose, onBookConsultation }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !service) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-card rounded-2xl shadow-elevated max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border px-6 md:px-8 py-6 flex items-center justify-between z-10">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
              <Icon name={service?.icon} size={24} color="var(--color-primary)" />
            </div>
            <h2 className="text-2xl md:text-3xl font-headline font-bold text-foreground">
              {service?.title}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-lg hover:bg-muted flex items-center justify-center transition-colors duration-300"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-6 md:p-8 lg:p-10">
          <div className="mb-8">
            <h3 className="text-lg font-headline font-semibold text-foreground mb-3">
              Overview
            </h3>
            <p className="text-base text-muted-foreground leading-relaxed">
              {service?.fullDescription}
            </p>
          </div>

          <div className="mb-8">
            <h3 className="text-lg font-headline font-semibold text-foreground mb-4">
              Key Features
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {service?.keyFeatures?.map((feature, index) => (
                <div key={index} className="flex items-start gap-3 p-4 bg-muted rounded-lg">
                  <Icon name="CheckCircle2" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-foreground">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-8">
            <h3 className="text-lg font-headline font-semibold text-foreground mb-4">
              Deliverables
            </h3>
            <div className="space-y-3">
              {service?.deliverables?.map((deliverable, index) => (
                <div key={index} className="flex items-start gap-3">
                  <Icon name="Package" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-foreground">{deliverable}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="p-6 bg-muted rounded-xl text-center">
              <Icon name="Clock" size={32} color="var(--color-primary)" className="mx-auto mb-3" />
              <div className="text-sm text-muted-foreground mb-1">Duration</div>
              <div className="text-lg font-headline font-bold text-foreground">{service?.duration}</div>
            </div>
            <div className="p-6 bg-muted rounded-xl text-center">
              <Icon name="Users" size={32} color="var(--color-primary)" className="mx-auto mb-3" />
              <div className="text-sm text-muted-foreground mb-1">Success Rate</div>
              <div className="text-lg font-headline font-bold text-foreground">{service?.successRate}</div>
            </div>
            <div className="p-6 bg-muted rounded-xl text-center">
              <Icon name="TrendingUp" size={32} color="var(--color-primary)" className="mx-auto mb-3" />
              <div className="text-sm text-muted-foreground mb-1">Clients Served</div>
              <div className="text-lg font-headline font-bold text-foreground">{service?.clientsServed}</div>
            </div>
          </div>

          {service?.complianceInfo && (
            <div className="mb-8 p-6 bg-success/5 border border-success/20 rounded-xl">
              <div className="flex items-start gap-3">
                <Icon name="Shield" size={24} color="var(--color-success)" className="flex-shrink-0" />
                <div>
                  <h4 className="text-base font-headline font-semibold text-foreground mb-2">
                    FIFA Compliance
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    {service?.complianceInfo}
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              variant="default"
              size="lg"
              fullWidth
              iconName="Calendar"
              iconPosition="left"
              onClick={onBookConsultation}
            >
              Book Consultation
            </Button>
            <Button
              variant="outline"
              size="lg"
              fullWidth
              iconName="Download"
              iconPosition="left"
            >
              Download Service Guide
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;